import { render, staticRenderFns } from "./SearchbarSuggestedClassified.vue?vue&type=template&id=682a2048&scoped=true&"
import script from "./SearchbarSuggestedClassified.vue?vue&type=script&lang=ts&"
export * from "./SearchbarSuggestedClassified.vue?vue&type=script&lang=ts&"
import style0 from "./SearchbarSuggestedClassified.vue?vue&type=style&index=0&id=682a2048&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682a2048",
  null
  
)

export default component.exports